import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import Button from 'components/common/Button';
import { UPDATE_STUDENT_PROFILE } from 'graphql/student/Profile';
import useSnack from 'hooks/useSnack';
import { useMutation } from 'react-apollo';
import Cookies from 'universal-cookie';
import Layout from './components/Layout';

const cookies = new Cookies();
const useStyles = makeStyles((theme) => ({
  actions: {
    '& button': {
      marginRight: theme.spacing(1),
    },
    [theme.breakpoints.down('sm')]: {
      '& button': {
        width: '100%',
        margin: 0,
        marginBottom: theme.spacing(2),
      }
    }
  }
}));

const OnBoarding = (props) => {
  const { history } = props;
  const classes = useStyles();
  const user = useSelector((u) => u.user.user);
  const snack = useSnack();
  const [update] = useMutation(UPDATE_STUDENT_PROFILE);

  const closeOnboarding = async () => {
    await cookies.set('onboarding_skip', true);
    props.history.push('/');
  };

  const muteReminder = () => {
    return update({
      variables: {
        id: user.id,
        input: {
          onboarding_done: true,
        },
      },
    }).then(
      async () => {
        await cookies.set('onboarding_skip', true);
        snack.success('Reminder Muted');
        history.push(`/`);
      },
      (e) => {
        snack.error(e.message);
      },
    );
  };

  return (
    <Layout step={0}>
      <Box
        flex={1}
        display="flex"
        flexDirection="column"
        paddingTop={{ md: 5 }}
      >
        <Typography color="textPrimary" variant="h3">
          Hi {user?.fname}! 👋
        </Typography>
        <Box marginBottom={{ xs: 2, md: 5 }} marginTop={{ xs: 3, md: 8 }}>
          <Typography paragraph color="textSecondary">
          We are here to help you achieve your goals and support you through one of the most important decisions in your life, but before this, we need to know you better!
          </Typography>
        </Box>
        <Typography color="textSecondary">
          Fill out this form, and you will be ready to start the journey 🚀
        </Typography>
        <Box display={{xs: 'block', md: 'flex' }} className={classes.actions} marginTop={5} textAlign="center">
          <Button
            onClick={closeOnboarding}
            size="large"
            variant="outlined"
            color="primary"
          >
            Remind me the next time
          </Button>
          <Button
            onClick={() => props.history.push('/onboarding/1/personal')}
            size="large"
            variant="contained"
            color="primary"
          >
            Go to the onboarding quiz
          </Button>
        </Box>
        <Box marginTop="auto" marginBottom={{ xs: 2, md: 5 }}>
          <Button
            onClick={muteReminder}
            startIcon={<NotificationsOffIcon />}
            color="primary"
          >
            Mute this Reminder
          </Button>
        </Box>
      </Box>
    </Layout>
  );
};

export default OnBoarding;
